import { quickEntries, heroStats } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section
      id="top"
      className="relative overflow-hidden bg-background-100 border-b border-background-200 scroll-mt-24"
    >
      <div className="absolute -top-24 -left-24 w-72 h-72 rounded-full bg-primary-200/40 blur-3xl"></div>
      <div className="absolute bottom-0 right-1/3 w-64 h-64 rounded-full bg-accent-200/40 blur-3xl"></div>

      <div className="relative px-6 lg:px-10 pt-12 md:pt-16 pb-12 md:pb-16 grid grid-cols-1 lg:grid-cols-[1.4fr_0.6fr] gap-10 lg:gap-14 items-center">
        <div className="animate-fadeUp">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 border border-background-300 text-xs text-foreground-700">
            <i className="ri-bookmark-3-line text-primary-500"></i>
            专题合集浏览 · 资源索引
          </span>

          <h1 className="mt-6 font-heading font-bold text-foreground-950 text-3xl md:text-5xl leading-tight max-w-3xl">
            蘑菇视频在线观看
            <span className="block mt-2 text-foreground-800">
              热门视频资源与短视频合集一站速览
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-base leading-relaxed text-foreground-600 max-w-2xl">
            想找蘑菇视频的热门内容和资源？这里把在线观看入口、热门视频与短视频合集汇总在一起，帮你快速定位有什么好看的，
            省去逐个翻找的时间，轻松跟上大家正在讨论的话题。
          </p>

          <div className="mt-8 rounded-lg bg-background-50 border border-background-300 p-4 md:p-5">
            <div className="flex items-center justify-between mb-3">
              <span className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                <i className="ri-login-box-line text-primary-500"></i>
                快速入口条
              </span>
              <span className="font-label text-[11px] tracking-[0.16em] uppercase text-foreground-400 hidden sm:block">
                Quick Entry
              </span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5">
              {quickEntries.map((entry) => (
                <a
                  key={entry.href}
                  href={entry.href}
                  className="group flex items-center gap-2.5 px-3.5 py-3 rounded-md bg-background-100 hover:bg-primary-50 border border-background-200 hover:border-primary-200 transition-colors cursor-pointer"
                >
                  <span className="w-8 h-8 shrink-0 rounded-md bg-background-50 text-primary-600 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                    <i className={`${entry.icon} text-[17px]`}></i>
                  </span>
                  <span className="text-sm text-foreground-800 whitespace-nowrap">
                    {entry.label}
                  </span>
                </a>
              ))}
            </div>
          </div>

          <div className="mt-8 flex flex-wrap items-center gap-x-8 gap-y-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="flex items-baseline gap-2">
                <span className="font-label text-2xl md:text-3xl text-foreground-950">
                  {stat.value}
                </span>
                <span className="text-xs text-foreground-500">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="relative hidden lg:block">
          <div className="w-full h-[440px] rounded-xl overflow-hidden border border-background-300 bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20poster%20with%20warm%20vermillion%20and%20amber%20organic%20shapes%20inspired%20by%20mushroom%20caps%2C%20textured%20paper%20grain%2C%20soft%20shadows%2C%20minimalist%20composition%2C%20cream%20background%2C%20calm%20modern%20visual%20rhythm%2C%20high%20detail%2C%20harmonious%20warm%20colors&width=720&height=900&seq=mushroom-hero-deco-01&orientation=portrait"
              alt="蘑菇视频专题合集浏览视觉"
              title="蘑菇视频 热门视频与短视频合集"
              className="w-full h-full object-top"
            />
          </div>
          <div className="absolute -bottom-5 left-5 right-5 rounded-lg bg-background-50 border border-background-300 px-4 py-3.5">
            <p className="text-xs text-foreground-500 flex items-center gap-2">
              <i className="ri-stack-line text-primary-500"></i>
              本页收录 42 个在架专题合集
            </p>
            <p className="mt-1.5 text-sm text-foreground-900">
              先看索引，再挑一集，效率比乱翻高得多。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}